import BasicService from "./BasicService";

class Account extends BasicService {
  constructor() {
    super();
  }

  getAccountDeliverys() {
    let url = `/useraccounts/delivery`
    return this.axios.get(url).then(request => request.data);
  }

  // Change User Pass
  changePassword(currentPassword, newPassword) {
    let url = `useraccounts/changepassword/`
    return this.axios.get(url,
      {
        params: {
          currentPassword,
          newPassword
        }
      }).then(request => request.data);
  }

  //   account
  deleteAccount(account) {
    let url = `/useraccounts/${account.userAccountId}`;
    return this.axios.delete(url, account).then(request => request.data);
  }
  updateAccount(account) {
    let url = `/useraccounts/${account.userAccountId}`;
    return this.axios.put(url, account).then(request => request.data);
  }
  addAccount(account) {
    let url = `/useraccounts`;
    return this.axios.post(url, account).then(request => request.data);
  }
  getAccount(userTypeName) {
    let url = `/useraccounts`;
    return this.axios.get(url,{params:{
      userTypeName
    }}).then(request => request.data);
  }
  getUserType() {
    let url = `/usertypes`;
    return this.axios.get(url).then(request => request.data);
  }

  getOnesignalAccount(){
    let url = `/onesignalAccount`;
    return this.axios.get(url).then(request => request.data);
  }
  getUiAccess() {
    let url = `/uiaccess`;
    return this.axios.get(url).then(request => request.data);
}
getUserCount(userTypeName) {
  let url = `/useraccounts/usercount`;
  return this.axios.get(url,{params:{
    userTypeName
  }}).then(request => request.data);
}
getDailyPercent(fromDate,toDate) {
  let url = `/useraccounts/percent`;
  return this.axios.get(url,{params:{
    fromDate,toDate
  }}).then(request => request.data);
}
updatePercent(dailyPercent) {
  let url = `/useraccounts/percent`;
  return this.axios.put(url,dailyPercent).then(request => request.data);
}
deletePercent(dailyId) {
  let url = `/useraccounts/percent/${dailyId}`;
  return this.axios.delete(url).then(request => request.data);
}
getUi(userTypeId) {
  let url = `/ui`;
  return this.axios.get(url,{params:{
    userTypeId
  }}).then(request => request.data);
}
updateUi(uiAccept) {
  let url = `/ui`;
  return this.axios.put(url,uiAccept).then(request => request.data);
}
getUiByUserId() {
  let url = `/ui/userId`;
  return this.axios.get(url).then(request => request.data);
}
}

const accountUserService = new Account();
export default accountUserService;